module.exports = __webpack_public_path__ + "images/ADT_Corporation-a69c9c.png";